package tta.destinigo.talktoastro.feature_chat_consultation_new.domain

enum class MsgType(val value: Int) {
    CONCERN_IMAGE(0), NORMAL_MSG(1), CONCERN_ANSWER(2), CONCERN_QUESTION(3), NORMAL_IMAGE(4)
}